import { render } from "./OldPopupYAML.vue?vue&type=template&id=61db9e8a&scoped=true"
import script from "./OldPopupYAML.vue?vue&type=script&lang=js"
export * from "./OldPopupYAML.vue?vue&type=script&lang=js"

import "./OldPopupYAML.vue?vue&type=style&index=0&id=61db9e8a&scoped=true&lang=css"
import "./OldPopupYAML.vue?vue&type=style&index=1&id=61db9e8a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61db9e8a"]])

export default __exports__